module.exports = __webpack_public_path__ + "img/29-green.6d845e72.svg";